import React from 'react';
import { Breadcrumbs, BreadcrumbsItem } from 'fronton-react';
import { analyticsUtils, patchUrlByLocale } from 'utils';
import { pdpSectionStyle } from 'common/components/page-section';
import { Breadcrumb } from 'features/page-model';
import { cx } from 'linaria';
import { getBreadcrumbsPath } from './get-breadcrumbs-path';

import { section } from './styles';

export const PDP_BREADCRUMPS_ID = 'breadcrumbs';

type Props = { data: Breadcrumb[] } & React.HTMLAttributes<HTMLElement>;

export const PdpBreadcrumps: React.FC<Props> = ({ data, className }) => {
  function sendGA(index: number) {
    const elementBlock = getBreadcrumbsPath(data);
    const elementText = getBreadcrumbsPath(data.slice(0, index + 1));

    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementName: 'breadcrumbs',
      elementText,
      elementBlock,
    });
  }

  return (
    <section data-qa={PDP_BREADCRUMPS_ID} className={cx(pdpSectionStyle, section, className || '')}>
      <Breadcrumbs addSEOAttributes={false}>
        {data.map(({ link, label }, index) => (
          <BreadcrumbsItem onClick={() => sendGA(index)} key={link} href={patchUrlByLocale(link)}>
            {label}
          </BreadcrumbsItem>
        ))}
      </Breadcrumbs>
    </section>
  );
};
